<template>
  <div style="width: 1300px; margin-left: -200px">
    <a-row id="analyse_table_labels">
      <a-col :span="2"></a-col>
      <a-col :span="2">Cotisations totales</a-col>
      <a-col :span="2">TSA + TSCA</a-col>
      <a-col :span="2">Conseil & assureur</a-col>
      <a-col :span="2">Gestion</a-col>
      <a-col :span="2">Cotisations nettes</a-col>
      <a-col :span="2">Forfait patientèle</a-col>
      <a-col :span="2">Prestations</a-col>
      <a-col :span="2">Prestations à payer</a-col>
      <a-col :span="2">Prestations totales</a-col>
      <a-col :span="2">Résultat</a-col>
      <a-col :span="2">Rapport S/P</a-col>
    </a-row> 
    <a-row
      v-for="t in json_data_table"
      class="analyse_table_values"
      :key="t.key"
    >
      <a-col :span="2" style="text-align: center">{{ t.label }}</a-col>
      <a-col :span="2">{{ t.coti_total }} €</a-col>
      <a-col :span="2">{{ t.tsa_tsca }} €</a-col>
      <a-col :span="2">{{ t.cons_assur }} €</a-col>
      <a-col :span="2">{{ t.gst }} €</a-col>
      <a-col :span="2">{{ t.coti_net }} €</a-col>
      <a-col :span="2">{{ t.fp }} €</a-col>
      <a-col :span="2">{{ t.presta }} €</a-col>
      <a-col :span="2">{{ t.presta_pay }} €</a-col>
      <a-col :span="2">{{ t.presta_total }} €</a-col>
      <a-col :span="2">{{ t.result }} €</a-col>
      <a-col :span="2">{{ t.rapport_sp }}</a-col>
    </a-row>

    <a-row id="analyse_table_totals">
      <a-col :span="2" style="text-align: center">
        <strong>{{ tt.label }}</strong>
      </a-col>
      <a-col :span="2"> {{ tt.coti_total }} € </a-col>
      <a-col :span="2">{{ tt.tsa_tsca }} €</a-col>
      <a-col :span="2"> {{ tt.cons_assur }} € </a-col>
      <a-col :span="2"> {{ tt.gst }} € </a-col>
      <a-col :span="2">{{ tt.coti_net }} €</a-col>
      <a-col :span="2">{{ tt.fp }} €</a-col>
      <a-col :span="2">{{ tt.presta }} €</a-col>
      <a-col :span="2">{{ tt.presta_pay }} € </a-col>
      <a-col :span="2">{{ tt.presta_total }} € </a-col>
      <a-col :span="2">{{ tt.result }} €</a-col>
      <a-col :span="2">{{ tt.rapport_sp }}</a-col>
    </a-row>
  </div>
</template>

<script>
import An from "../../AnimateNumber.vue";
export default {
  components: {
    An,
  },
  props: {
    timestamp: {
      type: Number,
      required: true,
    },
    action: {
      type: String,
      required: true,
    },
    json_data_table: {
      type: Object,
      required: true,
    },
    tt: {
      type: Object,
      required: true,
    },
  },
  computed: {},
};
</script>

<style scoped>
#analyse_table_labels,
#analyse_table_totals,
.analyse_table_values {
  margin-bottom: 4px;
}
#analyse_table_labels div:not(:first-child) {
  padding: 4px;
  text-align: center;
  background-color: #1890ff;
  color: white;
  border: 1px solid white;
}
#analyse_table_totals div:not(:first-child) {
  padding: 4px;
  text-align: center;
  background-color: #1890ff;
  color: white;
  border: 1px solid white;
  font-weight: bold;
}
.analyse_table_values div:not(:first-child) {
  padding: 4px;
  text-align: right;
  background-color: white;
  border: 1px solid #f1f1f1;
  font-size: 0.8em;
}
</style>